import { Component } from '@angular/core';
import { IonicPage, ToastController, PopoverController, Popover, LoadingController, Events } from 'ionic-angular';
import { pouchdb2 } from '../../services/pouchdb/pouchdb.service';
import { APIOnLine } from '../../services/api/api.services';
import { PaginaBasica } from '../../models/PaginaBase';
import { NuevoMenuDerechoComponent } from '../../components/nuevo-menu-derecho/nuevo-menu-derecho';
import { Proxy } from '../../services/proxy/proxy.service';
import { iConfiguracion } from '../../models/basePage';

@IonicPage()
@Component({
  selector: 'page-goles',
  templateUrl: 'goles.html',
})
export class GolesPage extends PaginaBasica {

  //#region Propiedades del controlador
  public designacion: Proxy.PrDesignaciones;
  public idEquipo: number;
  public licencias: Proxy.ListaPrPersonaAlineable;
  public participantes: Proxy.ListaPrParticipacion;
  public cambios: Proxy.ListaPrCambios;

  public goles: Proxy.ListaPrGoles;
  public golesPP: Proxy.ListaPrGoles;

  public pruebas: boolean = false;

  constructor(
    public CFutbolActas: APIOnLine.CFutbolActas,
    public DBService2: pouchdb2.DBService2,
    public events: Events,
    public loadingCtrl: LoadingController,
    public Persistentes: APIOnLine.Persistentes,
    public popOverCtrl: PopoverController,
    public toastCtrl: ToastController
  ) {
    super(loadingCtrl, toastCtrl);
  }

  ionViewDidLoad() {
    console.log('--- ENTRO EN LA PÁGINA: GOLES ---');

    this.designacion = this.Persistentes.GetDesignacion();
    this.idEquipo = this.Persistentes.GetIdEquipo();

    this.MostrarOcultarCarga(false, "cargando goles");

    this.licencias = new Proxy.ListaPrPersonaAlineable(this.CFutbolActas, this.DBService2, this.Persistentes, this.designacion, this.idEquipo);
    this.participantes = new Proxy.ListaPrParticipacion(this.CFutbolActas, this.DBService2, this.Persistentes, this.toastCtrl, this.designacion, this.idEquipo);
    this.cambios = new Proxy.ListaPrCambios(this.CFutbolActas, this.DBService2, this.Persistentes, this.toastCtrl, this.designacion, this.idEquipo);
    this.goles = new Proxy.ListaPrGoles(this.CFutbolActas, this.DBService2, this.Persistentes, this.toastCtrl, this.designacion, this.idEquipo);
    this.golesPP = new Proxy.ListaPrGoles(this.CFutbolActas, this.DBService2, this.Persistentes, this.toastCtrl, this.designacion, this.idEquipo);

    this.Persistentes.GetConfiguracion()
      .then((resultado: iConfiguracion) => {
        console.log("Configuración: ");
        console.log(resultado);
        this.pruebas = resultado.pruebas;
        return this.participantes.CargarListaParticipacion();
      })
      .then((resultado: boolean) => {
        return this.licencias.ObtenerAlineables(true, false, false);
      })
      .then((resultado: boolean) => {
        return this.cambios.CargarCambios();
      })
      .then((resultado: boolean) => {
        return this.goles.CargarGoles();
      })
      .then((resultado: boolean) => {
        // Quitar la lista de goles en propia puerta, para ponerlos en la otra lista
        if (this.goles != null && this.goles.lista != null && this.goles.lista.length > 0) {
          this.goles.lista.forEach((valor: Proxy.PrGolesConTotal, i: number) => {
            if (valor.propiaPuerta) {
              this.golesPP.lista.push(valor);
              this.goles.lista.splice(i, 1);
            }
          });
        }

        this.MostrarOcultarCarga();

      })
      .catch(error => this.Error(error, "ERROR al obtener la alineación de jugadores"));
  }

  //#region Métodos del controlador

  public AbrirMenuSecundario(event: any): void {
    let popover: Popover = this.popOverCtrl.create(NuevoMenuDerechoComponent);

    popover.present({
      ev: event
    });
  }

  public ActualizarResultado(): void {
    this.events.publish("cabecera:actualizarResultado");
  }

  public Aumentar(gol: Proxy.PrGolesConTotal): void {
    if (!gol.propiaPuerta) {
      this.goles.Aumentar(gol)
        .then((resultado: boolean) => {
          this.MensajeGol("Gol insertado correctamente");
          this.ActualizarResultado();
        })
        .catch(error => this.Error(error, "ERROR al aumentar un gol en la página de goles."));
    }
    else {
      this.golesPP.Aumentar(gol)
        .then((resultado: boolean) => {
          this.MensajeGol("Gol en propia puerta insertado correctamente");
          this.ActualizarResultado();
        })
        .catch(error => this.Error(error, "ERROR al aumentar un gol en la página de goles."));
    }
  }

  public Disminuir(gol: Proxy.PrGolesConTotal): void {
    if (!gol.propiaPuerta) {
      this.goles.Disminuir(gol)
        .then((resultado: boolean) => {
          this.MensajeGol("Gol eliminado correctamente");
          this.ActualizarResultado();
        })
        .catch(error => this.Error(error, "ERROR al disminuir un gol en la página de goles."));
    }
    else {
      this.golesPP.Disminuir(gol)
        .then((resultado: boolean) => {
          this.MensajeGol("Gol en propia puerta eliminado correctamente");
          this.ActualizarResultado();
        })
        .catch(error => this.Error(error, "ERROR al disminuir un gol en la página de goles."));
    }
  }

  public IncluirGoleador(participante: Proxy.PrParticipacion, propiaPuerta: boolean, penalty: boolean): void {
    if (!propiaPuerta) {
      this.goles.IncluirGoleador(participante, propiaPuerta, penalty)
        .then((resultado: boolean) => {
          this.MensajeGol("Gol insertado correctamente");
          this.ActualizarResultado();
        })
        .catch(error => this.Error(error, "ERROR al incluir un gol en la página de goles."));
    }
    else {
      this.golesPP.IncluirGoleador(participante, propiaPuerta, penalty)
        .then((resultado: boolean) => {
          this.MensajeGol("Gol en propia puerta insertado correctamente");
          this.ActualizarResultado();
        })
        .catch(error => this.Error(error, "ERROR al incluir un gol en la página de goles."));
    }
  }

  public MensajeGol(mensaje: string): void {
    this.Mensaje(mensaje + ". Resultado: " + this.Persistentes.GetGolesLocal().toString() + "-" + this.Persistentes.GetGolesVisitante(), 2000);
  }

  //#endregion
}



// WEBPACK FOOTER //
// ./src/pages/goles/goles.ts